// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"337":"ff2cbcae","561":"91c068db","677":"edc012f3","943":"39cae5d2"}[chunkId] + ".chunk.css";
};